/* Muaazon universal opt-in class for every merchant-theme button.
   No click interception, DOM wrapping, extra dependencies, or altered cart logic. */
(() => {
 if (window.__mzUniversalGlassReady) return;
 window.__mzUniversalGlassReady = true;
 const candidates='button,input[type="button"],input[type="submit"],input[type="reset"],a.button,a.foundation-button,a[role="button"],a.msg-action,a.msg-rail__link,a.mz-icon-rail__link,a.mv-quick__item,a.mv-mode,a.mz-home-hero__cta,a.mz-premium-hero__cta,a.ms-button,a.mz-home-hero__chip,a.mz-premium-hero__chip,a.welcome-offer__cta,a.product-form__cart-link,.mz-site-header__action,.mz-site-header__menu-toggle,.mz-site-header__search-submit,.mz-theme-toggle,.mz-bottom-nav__item,.msg-mainnav__all,.msg-mainnav__icon,.msg-search__submit,.msg-search__drawer-open,.msg-mobile-rail__item,.mobile-commerce-nav__item,.mv-bottom-nav__item,.mv-mode__btn,.mz-nav-drawer__close,.mz-icon-rail__brand,.mz-icon-rail__link';
 const excluded='.shopify-payment-button *, .shopify-challenge__container *,[data-shopify="payment-button"] *, [data-shopify="payment-button"],.product-card__swatch,.product-card__swatch *,.product-card__swatch-color,.product-card__swatch-color *,[role="radio"],[role="radio"] *,[role="option"],[role="option"] *,[data-product-card-swatch],.product-variant__swatch,.product-variant__swatch *,[data-color-swatch],[data-color-swatch] *,[data-mz-glass-exclude], [data-mz-glass-exclude] *';
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const fine=window.matchMedia('(hover:hover) and (pointer:fine)');
 const iconSelector='.icon-button,.product-card__quick-view,.product-card__swatch-more,.mz-variant-carousel__button,.product-sticky-atc__qty-btn,.mz-home-hero__arrow,.mz-premium-hero__arrow,.mz-home-hero__pause,.mz-home-hero__dot,[data-mhh-next],[data-mhh-prev],[data-mph-next],[data-mph-prev],.msg-action,.msg-rail__link,.mz-icon-rail__link,.mv-mode';
 const pseudoSelector='.product-card__quick-view,.msg-action,.msg-rail__link,.mz-icon-rail__link,.mv-mode,.mz-variant-carousel__button';
 function tag(el){
   if (el.closest(excluded)) return;
   if (el.classList.contains('mz-ui-glass')) return;
   el.classList.add('mz-ui-glass');
   if(el.matches(iconSelector)) el.classList.add('mz-ui-glass--icon');
   if(el.matches(pseudoSelector)) el.classList.add('mz-ui-glass--pseudo');
 }
 function scan(root){
   if(root.nodeType!==1 && root.nodeType!==9) return;
   if(root.nodeType===1 && root.matches(candidates)) tag(root);
   root.querySelectorAll?.(candidates).forEach(tag);
 }
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});
 else scan(document);
 document.addEventListener('shopify:section:load',e=>scan(e.target));
 /* Cards, quick views, drawers and filtered results render after page load. */
 let pending=false;
 const roots=new Set();
 const observer=new MutationObserver(records=>{
   for(const record of records) for(const node of record.addedNodes) if(node.nodeType===1) roots.add(node);
   if(!roots.size||pending) return;
   pending=true;
   requestAnimationFrame(()=>{ pending=false;for(const root of roots) scan(root);roots.clear(); });
 });
 observer.observe(document.documentElement,{childList:true,subtree:true});

 /* Reflection is event-delegated and coalesced to one read per frame. */
 let target=null,frame=false;
 function paint(el,x,y){
  if(!el?.isConnected) return;
  const r=el.getBoundingClientRect();
  if(r.width&&r.height){
   el.style.setProperty('--mz-reflection-x',((x-r.left)/r.width*100)+'%');
   el.style.setProperty('--mz-reflection-y',((y-r.top)/r.height*100)+'%');
  }
 }
 document.addEventListener('pointermove',e=>{
   if(!fine.matches||reduced.matches) return;
   const el=e.target.closest?.('.mz-ui-glass:not(.mz-liquid-glass):not(.mz-ui-glass--icon):not(.mz-ui-glass--pseudo)');
   if(!el) return;
   target={el,x:e.clientX,y:e.clientY};
   if(frame) return;
   frame=true;
   requestAnimationFrame(()=>{frame=false;if(target)paint(target.el,target.x,target.y)});
 },{passive:true});
 document.addEventListener('pointerdown',e=>{
   if(reduced.matches||e.button!==0) return;
   const el=e.target.closest?.('.mz-ui-glass:not(.mz-liquid-glass):not(.mz-ui-glass--icon):not(.mz-ui-glass--pseudo)');
   if(el) paint(el,e.clientX,e.clientY);
 },{passive:true});
 document.addEventListener('pointerout',e=>{
   const el=e.target.closest?.('.mz-ui-glass');
   if(!el||(e.relatedTarget&&el.contains(e.relatedTarget))) return;
   el.style.removeProperty('--mz-reflection-x');el.style.removeProperty('--mz-reflection-y');
   if(target?.el===el)target=null;
 },{passive:true});
})();
